import { render, staticRenderFns } from "./ExchangeWorks.vue?vue&type=template&id=6ea8fff2&scoped=true"
import script from "./ExchangeWorks.vue?vue&type=script&lang=js"
export * from "./ExchangeWorks.vue?vue&type=script&lang=js"
import style0 from "./ExchangeWorks.vue?vue&type=style&index=0&id=6ea8fff2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea8fff2",
  null
  
)

export default component.exports